import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { PackName } from '~src/interfaces/cycle.interface';
import { SegmentType } from '~src/interfaces/segment.interface';
import { SurveySubjectTypes } from '~src/interfaces/surveys.interfaces';
import AvatarBox, { AvatarType } from '~src/shared/avatarBox/AvatarBox';
import DaysLeft from '~src/shared/daysLeft/DaysLeft';

import { Tile, TileTitle, TileAvatar, TileTimeleft, TileStatus, TileName } from './surveyTile.sc';

export interface About {
  name: string;
  imageUrl?: string;
  type: SurveySubjectTypes;
  id: string;
}

interface StateProps {
  title: string;
  dueDate?: string;
  about: About;
  packName: PackName;
  cycleId: string;
  status: string;
  finished: boolean;
}

type Props = StateProps & WithTranslation;

interface State {
  viewMode: '';
}

const surveySubjectTypeToAvatarType = (subjectType: SurveySubjectTypes): AvatarType => {
  switch (subjectType) {
    case SurveySubjectTypes.People:
      return SegmentType.User;
    case SurveySubjectTypes.Groups:
      return SegmentType.Group;
    case SurveySubjectTypes.General:
      return SegmentType.Company;
    default:
      return SegmentType.Group;
  }
};

class SurveyTile extends React.Component<Props, State> {
  render() {
    const about = this.props.about;
    const href = `/questions/cycle/${this.props.cycleId}?precedent=${about.id}&selected_pack=${this.props.packName}`;

    return (
      <Tile href={href} className={this.props.finished ? 'finished' : ''}>
        <TileTitle title={this.props.title}>{this.props.title}</TileTitle>
        <TileTimeleft title={this.props.dueDate}>
          {this.props.dueDate && <DaysLeft t={this.props.t} date={this.props.dueDate} />}
        </TileTimeleft>
        <TileAvatar>
          <AvatarBox
            size={50}
            type={surveySubjectTypeToAvatarType(about.type)}
            url={about.imageUrl}
            name={about.name}
          />
        </TileAvatar>
        <TileName>{about.name}</TileName>
        <TileStatus title={this.props.status}>{this.props.status}</TileStatus>
      </Tile>
    );
  }
}

const SurveyTileT = withTranslation()(SurveyTile);

export default SurveyTileT;
